import { useState } from 'react';
import WizardCard from '../morning/WizardCard.jsx';

export default function StepBrainDump({ checkout, onUpdate, onBack, onFinish }) {
  const [local, setLocal] = useState(checkout?.brain_dump || '');

  function handleFinish() {
    const trimmed = local.trim();
    onUpdate({ brain_dump: trimmed || null });
    onFinish(trimmed);
  }

  return (
    <WizardCard
      step={4}
      totalSteps={4}
      title="Anything to brain-dump before tomorrow?"
      subtitle="Anything in here gets added to your Inbox."
      onBack={onBack}
      onNext={handleFinish}
      nextLabel="Finish check-out"
    >
      <textarea
        value={local}
        onChange={(e) => setLocal(e.target.value)}
        placeholder="Optional — leave blank to skip."
        rows={5}
        autoFocus
        className="w-full bg-bg-input border border-border-base rounded px-3 py-2 text-text-primary focus:outline-none focus:border-accent-blue resize-none"
      />
    </WizardCard>
  );
}
